import { render } from "./ConsumptionList.vue?vue&type=template&id=289922d8&scoped=true"
import script from "./ConsumptionList.vue?vue&type=script&lang=js"
export * from "./ConsumptionList.vue?vue&type=script&lang=js"

import "./ConsumptionList.vue?vue&type=style&index=0&id=289922d8&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289922d8"]])

export default __exports__